import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

const PaymentSuccess = () => {
  const [status, setStatus] = useState("checking");
  const sessionId = new URLSearchParams(window.location.search).get("session_id");

  useEffect(() => {
    if (!sessionId) return setStatus("unknown");
    let attempts = 0;
    const timer = setInterval(async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          clearInterval(timer);
        } else if (attempts > 20) {
          setStatus("timeout");
          clearInterval(timer);
        }
      } catch {
        if (attempts > 20) {
          setStatus("timeout");
          clearInterval(timer);
        }
      }
    }, 2500);
    return () => clearInterval(timer);
  }, [sessionId]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4" data-testid="payment-success-page">
      <div className="text-center max-w-md">
        {status === "paid" ? (
          <>
            <CheckCircle2 className="w-14 h-14 mx-auto text-emerald-400" />
            <h1 className="mt-6 text-3xl font-black" data-testid="payment-success-title">Paiement confirmé !</h1>
            <p className="mt-3 text-muted-foreground" data-testid="payment-success-text">
              Votre abonnement est activé et vos crédits ont été ajoutés à votre compte.
            </p>
          </>
        ) : status === "checking" ? (
          <>
            <Loader2 className="w-14 h-14 mx-auto text-[#8B5CF6] animate-spin" />
            <p className="mt-6 text-muted-foreground" data-testid="payment-checking-text">Vérification du paiement…</p>
          </>
        ) : (
          <>
            <XCircle className="w-14 h-14 mx-auto text-amber-400" />
            <h1 className="mt-6 text-2xl font-bold" data-testid="payment-pending-title">Paiement en cours de vérification</h1>
            <p className="mt-3 text-muted-foreground">Cela peut prendre quelques instants. Actualisez la page ou revenez plus tard.</p>
          </>
        )}
        <Button asChild className="mt-8 bg-gradient-to-r from-[#8B5CF6] to-[#EC4899] text-white border-0" data-testid="payment-success-studio-link">
          <Link to="/studio">Aller au Studio</Link>
        </Button>
      </div>
    </div>
  );
};

const PaymentCancel = () => (
  <div className="min-h-[70vh] flex items-center justify-center px-4" data-testid="payment-cancel-page">
    <div className="text-center max-w-md">
      <XCircle className="w-14 h-14 mx-auto text-muted-foreground" />
      <h1 className="mt-6 text-3xl font-black" data-testid="payment-cancel-title">Paiement annulé</h1>
      <p className="mt-3 text-muted-foreground">Aucun montant n'a été débité. Vous pouvez réessayer à tout moment.</p>
      <Button asChild className="mt-8 bg-gradient-to-r from-[#8B5CF6] to-[#EC4899] text-white border-0" data-testid="payment-cancel-pricing-link">
        <Link to="/tarifs">Revoir les offres</Link>
      </Button>
    </div>
  </div>
);

export { PaymentSuccess, PaymentCancel };
